import React, { useState } from 'react'

import WARNING_ICON from '@public/assets/duration_warning_triangle.svg'

type CloneDurationNoticeProps = {
  adjusted: boolean
  noticeId?: number
  adjustmentReason?: 'daily' | 'day'
  remainingHours?: number
  error?: boolean
}

export default function CloneDurationNotice({
  adjusted,
  noticeId = 0,
  remainingHours,
  error,
}: CloneDurationNoticeProps) {
  const exhausted = remainingHours === 0
  const message = error
    ? 'Unable to check daily hours. Reopen the entry to try again.'
    : exhausted
      ? "The day's total has reached 24 hours. Select another date before saving."
      : "The duration has been adjusted to keep the day's total within 24 hours."
  const noticeKey = `${noticeId}:${message}`
  const [dismissedKey, setDismissedKey] = useState<string | null>(null)

  if ((!adjusted && !exhausted && !error) || dismissedKey === noticeKey)
    return null

  return (
    <div
      role="status"
      className="flex w-full min-w-0 items-center justify-between gap-3 border-t border-[#D9D9D9] bg-[#FFFAEB] px-3 py-1.5 text-sm font-normal text-[#AD6500]"
    >
      <div className="flex min-w-0 flex-1 items-center gap-[5px]">
        <img src={WARNING_ICON} alt="" className="h-[15px] w-[15px] shrink-0" />
        <span className="min-w-0 break-words">{message}</span>
      </div>
      <button
        type="button"
        aria-label="Close duration information"
        onClick={() => setDismissedKey(noticeKey)}
        className="flex h-3.5 w-3.5 shrink-0 cursor-pointer items-center justify-center border-0 bg-transparent p-0 text-[#aeaeae] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
      >
        <svg
          className="h-[11px] w-2.5"
          viewBox="0 0 10 11"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M9.949 1.699 6.148 5.5l3.801 3.801-1.148 1.148L5 6.648l-3.801 3.801L.051 9.301 3.852 5.5.05 1.699 1.2.551 5 4.352 8.8.55 9.95 1.7Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </div>
  )
}
